import { combineReducers } from 'redux';

import createCampaignError from './createCampaignError';
import editCampaignError from './editCampaignError';
import switchCampaignStatusError from './switchCampaignStatusError';
import loadCampaignNamesError from './loadCampaignNamesError';

export default combineReducers({
  createCampaignError,
  editCampaignError,
  switchCampaignStatusError,
  loadCampaignNamesError,
});
